import { getRequest } from '../requests';
import { blobOrReject } from '../api';
import FileSaver from 'file-saver';
import Notification from '@rio-cloud/rio-uikit/Notification';
import { sendError } from '../../../../configuration/lang/services';
import { getMarketplaceBackend } from '../../config/appConfig';

export const downloadUsageAccountExcelReport = (accountId: string, year: number, month: number) => {
    const params = `?year=${year}&month=${month}`;
    return fetch(`${getMarketplaceBackend()}/admin/${accountId}/usages/export${params}`, getRequest())
        .then(blobOrReject)
        .then(response => FileSaver.saveAs(response, `RIO-Usages-${accountId}-${year}-${month}.xlsx`))
        .catch(error => {
            sendError(error);
            Notification.error('Error while downloading the usage excel');
        });
};
